export default __webpack_public_path__ + "static/media/discord-logo-white.9a823ca6.svg";